import { render, staticRenderFns } from "./myCommunity.vue?vue&type=template&id=f0d3d264&scoped=true"
import script from "./myCommunity.vue?vue&type=script&lang=js"
export * from "./myCommunity.vue?vue&type=script&lang=js"
import style0 from "./myCommunity.vue?vue&type=style&index=0&id=f0d3d264&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0d3d264",
  null
  
)

export default component.exports